import {doSuccessFailureActions} from '../_utils/actions.js';

export const FETCH_GROOMERS_FOR_SKIRESORT = doSuccessFailureActions('FETCH_GROOMERS');
export const DELETE_GROOMER = doSuccessFailureActions('DELETE_GROOMER');
export const MODIFY_GROOMER = doSuccessFailureActions('MODIFY_GROOMER');
export const ADD_GROOMER = doSuccessFailureActions('ADD_GROOMER');

export function fetchGroomersForSkiresort(parent) {
  return {type: FETCH_GROOMERS_FOR_SKIRESORT.do, parent};
}

export function fetchGroomersForSkiresortSuccess(items, parent) {
  return {type: FETCH_GROOMERS_FOR_SKIRESORT.success, items, parent};
}

export function fetchGroomersForSkiresortFailure(err, parent) {
  return {type: FETCH_GROOMERS_FOR_SKIRESORT.failure, err, parent};
}

// DELETE

export function deleteGroomer(id) {
  return {type: DELETE_GROOMER.do, id: id};
}

export function deleteGroomerSuccess(id) {
  return {type: DELETE_GROOMER.success, id: id};
}

export function deleteGroomerFailure(id, err) {
  return {type: DELETE_GROOMER.failure, id: id, err: err};
}


// MODIFY

export function modifyGroomer(payload) {
  return {type: MODIFY_GROOMER.do, payload: payload}
}

export function modifyGroomerSuccess(payload) {
  return {type: MODIFY_GROOMER.success, payload: payload}
}

export function modifyGroomerFailure(payload, err) {
  return {type: MODIFY_GROOMER.failure, payload: payload, err: err}
}


// ADD

export function addGroomer(payload) {
  return {type: ADD_GROOMER.do, payload: payload}
}

export function addGroomerSuccess(payload) {
  return {type: ADD_GROOMER.success, payload: payload}
}

export function addGroomerFailure(payload, err) {
  return {type: ADD_GROOMER.failure, payload: payload, err: err}
}



// WEBPACK FOOTER //
// ./src/redux/groomers/actions.js